import { createBrowserHistory } from "history";


const util = {};

util.history = createBrowserHistory();

export default util;